import React, { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import ImageMain from './images/landing_main2.jpg';
import BottomSectionMobile from './BottomSectionMobile';
import BottomSection from './BottomSection';
import SubSectionsCard from './SubSectionsCard';
import ScrollToTopButton from './ScrollToTopButton';
import Countdown from './Countdown';
import SEO, { organizationSchema, websiteSchema } from './components/SEO';

/* ──────────────────────────────────────────────
   Image imports: Topplista (favorites)
   ────────────────────────────────────────────── */
import imageFavorite1 from './images/landing_page/favorite/img1/1.jpg';
import imageFavorite1_1 from './images/landing_page/favorite/img1/image1f.jpg';
import imageFavorite2 from './images/landing_page/favorite/img2/1.jpg';
import imageFavorite1_2 from './images/landing_page/favorite/img2/image1f.jpg';
import imageFavorite3 from './images/landing_page/favorite/img3/1.jpg';
import imageFavorite1_3 from './images/landing_page/favorite/img3/image1f.jpg';
import imageFavorite4 from './images/landing_page/favorite/img4/1.jpg';
import imageFavorite1_4 from './images/landing_page/favorite/img4/image1f.jpg';
import imageFavorite5 from './images/landing_page/favorite/img5/1.jpg';
import imageFavorite1_5 from './images/landing_page/favorite/img5/image1f.jpg';
import imageFavorite6 from './images/landing_page/favorite/img6/1.jpg';
import imageFavorite1_6 from './images/landing_page/favorite/img6/image1f.jpg';
import imageFavorite7 from './images/landing_page/favorite/img7/1.jpg';
import imageFavorite1_7 from './images/landing_page/favorite/img7/image1f.jpg';
import imageFavorite8 from './images/landing_page/favorite/img8/1.jpg';
import imageFavorite1_8 from './images/landing_page/favorite/img8/image1f.jpg';
import imageFavorite9 from './images/landing_page/favorite/img9/1.jpg';
import imageFavorite1_9 from './images/landing_page/favorite/img9/image1f.jpg';
import imageFavorite10 from './images/landing_page/favorite/img10/1.jpg';
import imageFavorite1_10 from './images/landing_page/favorite/img10/image1f.jpg';
import imageFavorite11 from './images/landing_page/favorite/img11/1.jpg';
import imageFavorite1_11 from './images/landing_page/favorite/img11/image1f.jpg';
import imageFavorite12 from './images/landing_page/favorite/img12/1.jpg';
import imageFavorite1_12 from './images/landing_page/favorite/img12/image1f.jpg';

/* ──────────────────────────────────────────────
   Image imports: Nyheter (news)
   ────────────────────────────────────────────── */
import imageNews1 from './images/landing_page/news/img1/1.jpg';
import imageNews1_1 from './images/landing_page/news/img1/image1f.jpg';
import imageNews2 from './images/landing_page/news/img2/1.jpg';
import imageNews1_2 from './images/landing_page/news/img2/image1f.jpg';
import imageNews3 from './images/landing_page/news/img3/1.jpg';
import imageNews1_3 from './images/landing_page/news/img3/image1f.jpg';
import imageNews4 from './images/landing_page/news/img4/1.jpg';
import imageNews1_4 from './images/landing_page/news/img4/image1f.jpg';
import imageNews5 from './images/landing_page/news/img5/1.jpg';
import imageNews1_5 from './images/landing_page/news/img5/image1f.jpg';
import imageNews6 from './images/landing_page/news/img6/1.jpg';
import imageNews1_6 from './images/landing_page/news/img6/image1f.jpg';
import imageNews7 from './images/landing_page/news/img7/1.jpg';
import imageNews1_7 from './images/landing_page/news/img7/image1f.jpg';
import imageNews8 from './images/landing_page/news/img8/1.jpg';
import imageNews1_8 from './images/landing_page/news/img8/image1f.jpg';
import imageNews9 from './images/landing_page/news/img9/1.jpg';
import imageNews1_9 from './images/landing_page/news/img9/image1f.jpg';
import imageNews10 from './images/landing_page/news/img10/1.jpg';
import imageNews1_10 from './images/landing_page/news/img10/image1f.jpg';
import imageNews11 from './images/landing_page/news/img11/1.jpg';
import imageNews1_11 from './images/landing_page/news/img11/image1f.jpg';
import imageNews12 from './images/landing_page/news/img12/1.jpg';
import imageNews1_12 from './images/landing_page/news/img12/image1f.jpg';

/* ──────────────────────────────────────────────
   Image imports: Category sections
   ────────────────────────────────────────────── */
import image1 from './images/landing_page/image1.png';
import image2 from './images/landing_page/image2.jpeg';
import image3 from './images/landing_page/image33.jpg';
import image11 from './images/landing_page/image11.png';
import image12 from './images/landing_page/image12.png';
import image13 from './images/landing_page/image13.png';


/* ──────────────────────────────────────────────
   Data
   ────────────────────────────────────────────── */
const topplista = [
  { imageUrl: imageFavorite1, hoverImageUrl: imageFavorite1_1, title: 'Rökfyllda Drömmar', price: 149, imageId: '/pop-art/humans/ed28f9247a8e4eb4a21c5a316d6776b8' },
  { imageUrl: imageFavorite8, hoverImageUrl: imageFavorite1_8, title: 'Kaktusprinsessan', price: 149, imageId: '/pop-art/nature/89862336aa624257b80095a428e5284e' },
  { imageUrl: imageFavorite2, hoverImageUrl: imageFavorite1_2, title: 'Kattens Mystiska Blick', price: 149, imageId: '/illustration/animals/f5d2a1054bf54288bb58da89880d7b4e' },
  { imageUrl: imageFavorite3, hoverImageUrl: imageFavorite1_3, title: 'Vild och Fri', price: 149, imageId: '/abstract/animals/b3ba63a4172749b8b0787ccbb1b5be88' },
  { imageUrl: imageFavorite4, hoverImageUrl: imageFavorite1_4, title: 'Katt med Stil', price: 149, imageId: '/pop-art/animals/e7bb73023943454780c97d422f53b55c' },
  { imageUrl: imageFavorite5, hoverImageUrl: imageFavorite1_5, title: 'Capybarans Stadsäventyr', price: 149, imageId: '/photography/animals/f5e48d8772f8497d871df5a25ac20304' },
  { imageUrl: imageFavorite6, hoverImageUrl: imageFavorite1_6, title: 'Citrusens Strålande Ljus', price: 149, imageId: '/abstract/nature/cb53f8b35735496dbdbb599616088f4f' },
  { imageUrl: imageFavorite7, hoverImageUrl: imageFavorite1_7, title: 'Bohemisk Citrus Oas', price: 149, imageId: '/bohemian/nature/efcc541c04794c3e94ad1f63218af39c' },
  { imageUrl: imageFavorite9, hoverImageUrl: imageFavorite1_9, title: 'Jupiters Stormande Symfoni', price: 149, imageId: '/abstract/nature/a20faa1d68424dfe9fdb78509bb56c86' },
  { imageUrl: imageFavorite10, hoverImageUrl: imageFavorite1_10, title: 'Vattenmelons Värld', price: 149, imageId: '/abstract/nature/3f6089ecaeb945ecb8064d0730f6cabe' },
  { imageUrl: imageFavorite11, hoverImageUrl: imageFavorite1_11, title: 'Rosa Rosens Skönhet', price: 149, imageId: '/bohemian/nature/4122e7302e1e48d3bee47db118a8e0bc' },
  { imageUrl: imageFavorite12, hoverImageUrl: imageFavorite1_12, title: 'Kaktus med Vit Krona', price: 149, imageId: '/bohemian/nature/13acf683faf840a89580d0fe4d07113e' },
];

const nyheter = [
  { imageUrl: imageNews1, hoverImageUrl: imageNews1_1, title: 'Tropisk Skymningsljus', price: 149, imageId: '/pop-art/nature/c8a7025ff1ab4a518e92a7d5ab30d595' },
  { imageUrl: imageNews2, hoverImageUrl: imageNews1_2, title: 'Citrusskådespel: Färgernas Fest', price: 149, imageId: '/abstract/nature/2b50c70be4264b6daba7e5bad0c1abd1' },
  { imageUrl: imageNews3, hoverImageUrl: imageNews1_3, title: 'Krets Hamster Kraft', price: 149, imageId: '/futuristic/animals/dab09894e4c04b389dd7238b219047eb' },
  { imageUrl: imageNews4, hoverImageUrl: imageNews1_4, title: 'Framtidens Cybergroda', price: 149, imageId: '/futuristic/animals/29a02a3eefd94f3baa7fb954483466ba' },
  { imageUrl: imageNews5, hoverImageUrl: imageNews1_5, title: 'Panterns Ögon bakom Glasen', price: 149, imageId: '/pop-art/animals/9998c890f6694e1f9cd808fe2baced84' },
  { imageUrl: imageNews6, hoverImageUrl: imageNews1_6, title: 'Rikedomens Färgpalett', price: 149, imageId: '/pop-art/humans/1b961c9d73134346881fbb32d078122a' },
  { imageUrl: imageNews7, hoverImageUrl: imageNews1_7, title: 'Kanin Konstverk', price: 149, imageId: '/pop-art/animals/fa2b914d35b04065bae896dcdc7a2722' },
  { imageUrl: imageNews8, hoverImageUrl: imageNews1_8, title: 'Chic Hund med Glasögon', price: 149, imageId: '/pop-art/animals/af9cfef560e0454e955e616649f8558a' },
  { imageUrl: imageNews9, hoverImageUrl: imageNews1_9, title: 'Björnens Spår', price: 149, imageId: '/abstract/animals/5010533b453c4681b14a799229a3354a' },
  { imageUrl: imageNews10, hoverImageUrl: imageNews1_10, title: 'Urbana Valpens Stil', price: 149, imageId: '/photography/animals/53e647479a954199bc783b6ab461d8d6' },
  { imageUrl: imageNews11, hoverImageUrl: imageNews1_11, title: 'Katt med Attityd', price: 149, imageId: '/photography/animals/d7b3c2df60f64c40a349539b69ffb193' },
  { imageUrl: imageNews12, hoverImageUrl: imageNews1_12, title: 'Den Ädla Purr', price: 149, imageId: '/fantasy/animals/2320179a059d45dd91ea0b2d95e4e71e' },
];

const categoryImages = [
  { imageUrl: image11, style: 'fantasy', label: 'Fantasy' },
  { imageUrl: image12, style: 'pop-art', label: 'Pop-art' },
  { imageUrl: image13, style: 'futuristic', label: 'Cyberpunk' },
];

const styleImages = [
  { imageUrl: image1, style: 'abstract', label: 'Abstrakt' },
  { imageUrl: image2, style: 'photography', label: 'Fotografi' },
];

const illustrationImage = { imageUrl: image3, style: 'illustration', label: 'Illustration' };

/* ──────────────────────────────────────────────
   SEO Accordion Data
   ────────────────────────────────────────────── */
const seoSections = [
  {
    title: 'Stilfulla posters och konstverk för alla rum',
    text: 'Elegant design behöver inte kosta mycket. På Postertopia har vi prisvärda posters i olika stilar, från stora konstverk till mindre fotografier och illustrationer. Våra posters är inspirerade av internationella trender och passar i många hem.',
  },
  {
    title: 'Skapa en harmonisk tavelvägg med våra posters',
    text: 'En tavelvägg låter dig kombinera olika posters för att skapa en unik atmosfär. Med vårt brett sortiment kan du inreda kostnadseffektivt och enligt trend. Skapa en estetisk tavelvägg med våra abstrakta, futuristiska eller fotografiska posters.',
  },
  {
    title: 'Utforska olika stilar och format för din tavelvägg',
    text: 'Kombinera posters i olika storlekar och stilar för att skapa en dynamisk tavelvägg. Vi erbjuder posters i flera format. Utforska vårt sortiment på vår inspirationssida och tagga din poster på Instagram med @Postertopia!',
  },
  {
    title: 'Motiv med människor, djur, natur, arkitektur och mer',
    text: 'I vårt sortiment hittar du motiv som inkluderar människor, djur, natur och mer. Vi strävar efter att erbjuda en varierad samling konstverk för att skapa en unik atmosfär i ditt hem. Utforska vårt utbud och ge ditt hem en personlig touch med våra inspirerande konstverk!',
  },
];


/* ══════════════════════════════════════════════
   COMPONENTS
   ══════════════════════════════════════════════ */

/** Single product card with hover image swap */
const ProductCard = ({ item, hoveredId, onHover, onLeave }) => (
  <Link to={item.imageId} className="group block no-underline text-inherit">
    <motion.div whileTap={{ scale: 0.98 }}>
      <div className="relative bg-gray-100">
        <img
          loading="lazy"
          src={hoveredId === item.imageId ? item.hoverImageUrl : item.imageUrl}
          alt={item.title}
          className="w-full h-auto block transition-transform duration-300 group-hover:scale-105"
          onMouseEnter={() => onHover(item.imageId)}
          onMouseLeave={onLeave}
        />
      </div>
      <div className="mt-2.5 px-0.5">
        <p className="text-sm font-medium text-gray-900 truncate">{item.title}</p>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-sm font-semibold text-gray-900">Från {item.price} kr</span>
          <span className="text-xs text-red-500 line-through">200 kr</span>
        </div>
      </div>
    </motion.div>
  </Link>
);

/** Product grid section (Topplista / Nyheter) */
const ProductGrid = ({ title, items, isMobile, hoveredId, onHover, onLeave }) => {
  const displayItems = items.slice(0, 6);

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
      {/* Section header */}
      <div className="text-center mb-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">{title}</h2>
        <div className="w-16 h-0.5 bg-gray-900 mx-auto mt-3" />
      </div>

      {/* Grid */}
      <div className={`grid gap-4 sm:gap-6 ${isMobile ? 'grid-cols-2' : 'grid-cols-3 lg:grid-cols-6'}`}>
        {displayItems.map((item) => (
          <ProductCard
            key={item.imageId}
            item={item}
            hoveredId={hoveredId}
            onHover={onHover}
            onLeave={onLeave}
          />
        ))}
      </div>
    </section>
  );
};

/** Category card with overlay label */
const CategoryCard = ({ image, onClick, isMobile }) => (
  <motion.div
    whileHover={{ scale: 1.02 }}
    whileTap={{ scale: 0.98 }}
    className="relative cursor-pointer overflow-hidden rounded-xl"
    onClick={() => onClick(image.style)}
  >
    <Link to={`/${image.style}/`} className="block">
      <img
        loading="lazy"
        src={image.imageUrl}
        alt={`${image.label} Poster Tema`}
        className="w-full h-48 sm:h-64 md:h-80 object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
      <span className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black text-white text-sm sm:text-base font-bold px-6 py-2.5 rounded">
        {image.label}
      </span>
    </Link>
  </motion.div>
);

/** SEO accordion item */
const SeoAccordionItem = ({ section, isOpen, onToggle, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ delay: index * 0.08, duration: 0.35 }}
  >
    <div className={`rounded-lg mb-2 transition-colors duration-200 ${isOpen ? 'bg-white shadow-sm' : 'bg-gray-50 hover:bg-gray-100'}`}>
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between py-4 px-5 bg-transparent border-none cursor-pointer text-left"
      >
        <h3 className="text-sm sm:text-[15px] font-semibold text-gray-800 pr-4 m-0 leading-snug">
          {section.title}
        </h3>
        <span className={`flex items-center justify-center w-7 h-7 rounded-full flex-shrink-0 transition-all duration-300 ${isOpen ? 'bg-gray-900 text-white rotate-180' : 'bg-gray-200 text-gray-500'}`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-3.5 h-3.5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
          </svg>
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-60 pb-5' : 'max-h-0'}`}>
        <p className="text-sm text-gray-500 leading-relaxed px-5 m-0">
          {section.text}
        </p>
      </div>
    </div>
  </motion.div>
);


/* ══════════════════════════════════════════════
   MAIN LANDING PAGE
   ══════════════════════════════════════════════ */
const LandingPage = (props) => {
  const isMobileView = useMediaQuery('(max-width:660px)');
  const navigate = useNavigate();

  const [hoveredId, setHoveredId] = useState(null);
  const [openSeoIndex, setOpenSeoIndex] = useState(null);

  const handleCategoryClick = (style) => {
    props.setDisplayPage('dashboard');
    props.setDisplayStyle(style);
  };

  return (
    <div className="relative">
      <SEO
        title="Köp Unika Posters och Konsttryck Online"
        description="Upptäck PosterTopias breda utbud av stilfulla och prisvärda posters. Från konstnärliga tryck till trendiga designer, hitta den perfekta inredningen för ditt utrymme. Snabb leverans i Sverige."
        path="/"
        jsonLd={[organizationSchema, websiteSchema]}
      />

      {/* ─── PROMO BANNER ─── */}
      <Link to="/rabatt" className="block no-underline">
        <div
          className="bg-brand-orange text-white text-center py-4 sm:py-5 mt-[140px] cursor-pointer"
          onClick={() => navigate('/rabatt')}
        >
          <h3 className="text-lg sm:text-xl font-bold m-0">
            {props.discountPercentage * 100}% rabatt på posters
          </h3>
          <div className="flex justify-center mt-3">
            <Countdown />
          </div>
        </div>
      </Link>

      {/* ─── HERO SECTION ─── */}
      <section className="relative mx-auto mt-4 px-3 sm:px-6 max-w-[1400px]">
        <div className="relative overflow-hidden rounded-2xl">
          <img
            src={ImageMain}
            alt="PosterTopia - Skapa din unika stil"
            className="w-full h-[500px] sm:h-[550px] md:h-[600px] object-cover"
          />
          {/* Dark overlay for text readability */}
          <div className="absolute inset-0 bg-black/30" />

          {/* Hero text */}
          <div className="absolute inset-0 flex flex-col items-center justify-center px-6">
            <h1 className="text-[7vw] sm:text-4xl md:text-5xl font-extrabold text-white text-center drop-shadow-lg m-0">
              SKAPA DIN UNIKA STIL
            </h1>
            <Link to="/topplista/" onClick={() => props.togglePage()}>
              <button className="mt-8 px-8 py-3.5 bg-black text-white text-lg font-bold rounded shadow-xl hover:bg-gray-900 transition-colors border-none cursor-pointer">
                SHOPPA NU
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* ─── TOPPLISTA GRID ─── */}
      <ProductGrid
        title="Topplista"
        items={topplista}
        isMobile={isMobileView}
        hoveredId={hoveredId}
        onHover={setHoveredId}
        onLeave={() => setHoveredId(null)}
      />

      {/* ─── CATEGORY SECTION: Fantasy / Pop-art / Cyberpunk ─── */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
        <div className="grid grid-cols-3 gap-3 sm:gap-5">
          {categoryImages.map((img) => (
            <CategoryCard
              key={img.style}
              image={img}
              onClick={handleCategoryClick}
              isMobile={isMobileView}
            />
          ))}
        </div>
      </section>

      {/* ─── NYHETER GRID ─── */}
      <ProductGrid
        title="Nyheter"
        items={nyheter}
        isMobile={isMobileView}
        hoveredId={hoveredId}
        onHover={setHoveredId}
        onLeave={() => setHoveredId(null)}
      />

      {/* ─── CATEGORY SECTION: Abstrakt / Fotografi ─── */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-5">
          {styleImages.map((img) => (
            <CategoryCard
              key={img.style}
              image={img}
              onClick={handleCategoryClick}
              isMobile={isMobileView}
            />
          ))}
        </div>
      </section>

      {/* ─── CATEGORY SECTION: Illustration (full-width) ─── */}
      {!isMobileView && (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-6">
          <CategoryCard
            image={illustrationImage}
            onClick={handleCategoryClick}
            isMobile={isMobileView}
          />
        </section>
      )}

      {/* ─── SEO TEXT / ABOUT SECTION ─── */}
      <section className="bg-stone-100 py-14 sm:py-20">
        <div className="max-w-2xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10">
            <p className="text-xs font-semibold tracking-[0.2em] text-gray-400 uppercase mb-2">
              Varför välja oss
            </p>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
              Posters Online hos PosterTopia
            </h2>
            <div className="w-10 h-[3px] bg-gray-900 mx-auto mt-4 rounded-full" />
          </div>
          <div>
            {seoSections.map((section, index) => (
              <SeoAccordionItem
                key={index}
                index={index}
                section={section}
                isOpen={openSeoIndex === index}
                onToggle={() => setOpenSeoIndex(openSeoIndex === index ? null : index)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* ─── TRUST BADGES ─── */}
      <SubSectionsCard isMobileView={isMobileView} />

      {/* ─── FOOTER ─── */}
      {isMobileView ? (
        <BottomSectionMobile
          setCookieConsentGiven={props.setCookieConsentGiven}
          setOpenCookieBar={props.setOpenCookieBar}
        />
      ) : (
        <BottomSection
          setCookieConsentGiven={props.setCookieConsentGiven}
          setOpenCookieBar={props.setOpenCookieBar}
          isMobileView={isMobileView}
        />
      )}

      <ScrollToTopButton />
    </div>
  );
};

export default LandingPage;
